module.exports = __webpack_public_path__ + "img/checked.1752b3e7.svg";